import axios, { AxiosInstance } from "axios";
import Vue from 'vue'

const validStatus: Array<number> = [ 200, 201, 204, 400, 401, 404, 405, 409, 415 ]

// Configure axios defaults here
export function createInstance(): AxiosInstance {
    return axios.create({
        // Axios will throw if response status is different than a valid status
        validateStatus: status => validStatus.find(validStatus => validStatus === status) !== undefined,
        headers: {
            "Access-Control-Allow-Origin": "*"
        }  
    })
}

export default {
    install () {
        Vue.prototype.$http = createInstance()
    }
}

declare module 'vue/types/vue' {
    interface Vue {
      $http: AxiosInstance
    }
}